import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api, extractData } from '@/lib/treaty';

import { getAuthenticatedQueryOptions } from './authenticated';

const deleteCookies = () => {
  return extractData(api.authcookie.delete());
};

export const createCookies = (idToken: string) => {
  return api.authcookie.get({ headers: { Authorization: idToken } });
};

export const useCreateAuthCookies = () => {
  const queryClient = useQueryClient();

  const createAuthCookie = useMutation({
    mutationFn: createCookies,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: getAuthenticatedQueryOptions().queryKey });
    },
  });

  return { createAuthCookie };
};

export const useDeleteAuthCookies = () => {
  const queryClient = useQueryClient();

  const deleteAuthCookie = useMutation({
    mutationFn: deleteCookies,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: getAuthenticatedQueryOptions().queryKey });
    },
  });

  return { deleteAuthCookie };
};

const deleteRefreshCookies = () => {
  return extractData(api.rtcookie.delete());
};

export const createRefreshCookies = (refreshToken: string) => {
  return api.rtcookie.post({ refreshToken: refreshToken });
};

export const getRefreshCookies = () => {
  return extractData(api.rtcookie.get());
};

export const useCreateRefreshCookies = () => {
  const queryClient = useQueryClient();

  const createRefreshCookie = useMutation({
    mutationFn: createRefreshCookies,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: getAuthenticatedQueryOptions().queryKey });
    },
  });

  return { createRefreshCookie };
};

export const useDeleteRefreshCookies = () => {
  const queryClient = useQueryClient();

  const deleteRefreshCookie = useMutation({
    mutationFn: deleteRefreshCookies,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: getAuthenticatedQueryOptions().queryKey });
    },
  });

  return { deleteRefreshCookie };
};
